module.exports = __webpack_public_path__ + "img/w3_search_black.3cd9b3f2.png";